import { render, staticRenderFns } from "./ArriveAddressList.vue?vue&type=template&id=587800ad&scoped=true"
import script from "./ArriveAddressList.vue?vue&type=script&lang=js"
export * from "./ArriveAddressList.vue?vue&type=script&lang=js"
import style0 from "./ArriveAddressList.vue?vue&type=style&index=0&id=587800ad&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587800ad",
  null
  
)

export default component.exports